<div class="app-container">
  <div class="background-image-wrapper">
    <div class="background-image"></div>
  </div>
  <app-header></app-header>
  <div class="app-content">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
